const fetchTimeData = async () => {
    const url = 'https://worldtimeapi.org/api/timezone/ETC/GMT';
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.unixtime;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export default fetchTimeData;

export const getCurrentTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getCurrentLocale = () => {
    return navigator.language || "en-US";
};